module.exports = __webpack_public_path__ + "static/owl-74349b3995015e67c709c3331c8f4ebc.png";